import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Heart, ShoppingCart } from "lucide-react";
import { czk, media, priceTxt } from "../lib/api";
import { useCart } from "../lib/store";

export const ProductCard = ({ p, i = 0 }) => {
  const { add, favs, toggleFav } = useCart();
  const fav = favs.some((f) => f.id === p.id);
  const sale = p.sale_price && p.sale_price < p.price;
  const sold = p.stock !== null && p.stock !== undefined && p.stock <= 0;
  return (
    <motion.article
      initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-40px" }} transition={{ delay: (i % 4) * 0.08 }}
      className="card-soft group relative flex flex-col overflow-hidden transition-transform duration-300 hover:-translate-y-1.5" data-testid={`product-card-${p.slug}`}
    >
      <Link to={`/produkt/${p.slug}`} className="relative block aspect-[4/3] overflow-hidden bg-[#EFEBE1]">
        {p.images?.[0] && <img src={media(p.images[0])} alt={p.name} loading="lazy" className="h-full w-full object-contain" />}
        {p.images?.[1] && <img src={media(p.images[1])} alt="" loading="lazy" className="absolute inset-0 h-full w-full bg-[#EFEBE1] object-contain opacity-0 transition-opacity duration-500 group-hover:opacity-100" />}
        <div className="absolute left-3 top-3 flex flex-col gap-1.5">
          {p.is_new && <span className="rounded-full bg-[#A3AC86] px-3 py-1 text-[11px] font-semibold text-white">Novinka</span>}
          {sale && <span className="rounded-full bg-[#D96B43] px-3 py-1 text-[11px] font-semibold text-white">-{Math.round(100 - (p.sale_price / p.price) * 100)} %</span>}
        </div>
      </Link>
      <button onClick={() => toggleFav(p)} className="absolute right-3 top-3 grid h-9 w-9 place-items-center rounded-full bg-white/90 backdrop-blur transition-transform hover:scale-110" data-testid={`fav-btn-${p.slug}`} aria-label="Oblíbené">
        <Heart className={`h-4 w-4 transition-colors ${fav ? "fill-[#D96B43] text-[#D96B43]" : ""}`} />
      </button>
      <div className="flex flex-1 flex-col p-4">
        <Link to={`/produkt/${p.slug}`} className="text-[15px] font-medium leading-snug hover:text-[#7A8460]">{p.name}</Link>
        <div className="mt-auto flex items-end justify-between pt-3">
          <div>
            <p className="text-lg font-bold" data-testid={`product-price-${p.slug}`}>{priceTxt(sale ? p.sale_price : p.price)}</p>
            {sale && <p className="text-xs text-[#6E7565] line-through">{czk(p.price)}</p>}
          </div>
          <motion.button whileTap={{ scale: 0.85 }} disabled={sold} onClick={() => add(p)} data-testid={`add-to-cart-${p.slug}`}
            className="grid h-10 w-10 place-items-center rounded-full bg-[#7A8460] text-white transition-all hover:rotate-[-8deg] hover:bg-[#687050] disabled:bg-gray-300" aria-label="Do košíku">
            <ShoppingCart className="h-4 w-4" />
          </motion.button>
        </div>
      </div>
    </motion.article>
  );
};
